import * as Enumeration from './Enumeration';

export const ReportType = [
  {
    text: 'Scheduled',
    type: Enumeration.ReportTypeEnum.Scheduled,
  },
  {
    text: 'Expired',
    type: Enumeration.ReportTypeEnum.Expired,
  },
];

export const SortType = [
  {
    text: 'Last Name',
    type: Enumeration.SortTypeEnum.LastName,
  },
  {
    text: 'Student Number',
    type: Enumeration.SortTypeEnum.StudentNumber,
  },
  {
    text: 'Family Number',
    type: Enumeration.SortTypeEnum.FamilyNumber,
  },
];

export const GroupBy = [
  {
    text: 'None',
    type: Enumeration.GroupTypeEnum.None,
  },
  {
    text: 'School',
    type: Enumeration.GroupTypeEnum.School,
  },
];

export const ProvisionType = [
  {
    text: 'CEP/Provision 2 Only',
    type: Enumeration.ProvisionTypeEnum.CEP,
  },
  {
    text: 'Traditional',
    type: Enumeration.ProvisionTypeEnum.Traditional,
  },
  {
    text: 'Both',
    type: Enumeration.ProvisionTypeEnum.Both,
  },
];

export const CarryoverType = [
  {
    text: 'Year End',
    type: Enumeration.CarryoverType.YearEnd,
  },
  {
    text: 'CEP Transfer',
    type: Enumeration.CarryoverType.CEP_Transfer,
  },
  {
    text: 'Both',
    type: Enumeration.CarryoverType.Both,
  },
];



// WEBPACK FOOTER //
// ./src/pages/mbereport/helpers/ButtonType.js